export default "__VITE_PUBLIC_ASSET__158138a7__"